import request from '@/utils/request';
// 列表
export function queryGoodsSetMealComboPageList(data) {
  return request({
    url: '/goods/set/meal/combo/queryGoodsSetMealComboPageList',
    method: 'POST',
    data
  });
}
// 删除
export function removeGoodsSetMealComboById(data) {
  return request({
    url: '/goods/set/meal/combo/removeGoodsSetMealComboById',
    method: 'POST',
    data
  });
}
// 新增商品套餐搭配
export function saveGoodsSetMealCombo(data) {
  return request({
    url: '/goods/set/meal/combo/saveGoodsSetMealCombo',
    method: 'POST',
    data
  });
}
// 修改商品套餐搭配
export function updateGoodsSetMealCombo(data) {
  return request({
    url: '/goods/set/meal/combo/updateGoodsSetMealCombo',
    method: 'POST',
    data
  });
}
// 获取商品套餐搭配明细
export function fetchGoodsSetMealComboDetailById(data) {
  return request({
    url: '/goods/set/meal/combo/fetchGoodsSetMealComboDetailById',
    method: 'POST',
    data
  });
}
// 添加商品套餐-获取商品列表
export function queryGoodsSpecSetMealComboPageList(data) {
  return request({
    url: '/goods/spec/set/meal/combo/queryGoodsSpecSetMealComboPageList',
    method: 'POST',
    data
  });
}



// WEBPACK FOOTER //
// ./src/api/setMenu.js